(ns machtfit.stepchall.leaderboard.nav
  (:require [machtfit.startpage.api-events :as api-events]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.subs :as subs]
            [re-frame.core :as rf]))

(rf/reg-event-fx ::clicked
  (fn [{:keys [db]} [_ scope]]
    (-> {:db db}
        (assoc-in [:db :ui :stepchall :leaderboard :scope] scope)
        api-events/api-requests-on-stepchall-event)))

(defn- button [{:keys [scope icon]}]
  [:button {:class (when (= @(rf/subscribe [:get [:ui :stepchall :leaderboard :scope]]) scope) "active")
            :on-click #(rf/dispatch [::clicked scope])}
   [:i.sc_icon icon]])

(rf/reg-sub ::show-participant-leaderboard?
  :<- [:get [:stepchall :show-participant-leaderboard?]]
  :<- [::subs/is-team-member?]

  (fn [[show-participant-leaderboard is-team-member?] _]
    (and show-participant-leaderboard is-team-member?)))

(defn nav []
  (when @(rf/subscribe [::show-participant-leaderboard?])
    [:div.sc_leaderboard-nav
     [:div.inner {:class (case @(rf/subscribe [:get [:ui :stepchall :leaderboard :scope]])
                           :teams "scope-teams"
                           :participants "scope-participants")}
      [button {:icon (icons/leaderboard-teams)
               :scope :teams}]
      [button {:icon (icons/leaderboard-participants)
               :scope :participants}]]]))
